"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function CheckMarkIcon(_ref) {
  var className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    style: style,
    viewBox: "0 0 15 13"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M1 6l4.615 5L14 1"
  }));
}

CheckMarkIcon.defaultProps = {
  className: undefined,
  style: undefined
};
CheckMarkIcon.propTypes = {
  className: _propTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: _propTypes.object
};
var _default = CheckMarkIcon;
exports.default = _default;
